import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../../store/views/entityView";
import { useNmmDomains } from "../../../../../hooks/useNmmDomains";
import { assessmentsByDomainQuery, currentCoursesByDomainFilters } from "../../../../../utils/entitiesFiltersUtils";
import AssessmentItem from "../../../../features/assessmentItem/AssessmentItem";
import Widget from "../../../../features/widget/Widget";
import iconsList from "../../../../ui/icons/iconsList";
import MyCourseItem from "../../../../features/courseItem/myCourseItem/MyCourseItem";
import SectionList from "../SectionList/SectionList";
import classes from "./CoursesAndAssessmnetsDomainWidget.module.css";

const CoursesAndAssessmnetsDomainWidget = ({ domainName, nmmId, nmmIds }) => {

    const { texts } = useSelector(state => state.translate);
    const nmmDomains = useNmmDomains();
    const filters = useMemo(() => currentCoursesByDomainFilters(domainName, nmmId, nmmDomains, nmmIds), [domainName, nmmId, nmmDomains, nmmIds]);
    const courses = useSelector(state => selectEntitiesByFilters(state, filters));
    const assessmentsQuery = useMemo(() => assessmentsByDomainQuery(domainName, nmmDomains), [domainName, nmmDomains]);
    const assessments = useSelector((state) => selectEntitiesByFilters(state, assessmentsQuery));

    return (
        <Widget
            icon={iconsList.myLearning}
            color="#FDDB71"
            title={texts.myLearningSubject}
            className={classes.CoursesAndAssessmentsWidget}
            contentScrollable={false}
        >
            <div className={classes.WidgetContent}>
                <div className={classes.EnvironmentsSection}>
                    <SectionList
                        titel={texts.environments}
                        classNameList={classes.CoursesList}
                        ItemComponent={MyCourseItem}
                        list={courses}
                        itemPropName={"course"}
                        textForEmptyList={texts.noEnvironmentsAvailable}
                    />
                </div>
                <div className={classes.AssessmentsSection}>
                    <SectionList
                        titel={texts.assessments}
                        classNameList={classes.AssessmentsList}
                        list={assessments}
                        ItemComponent={AssessmentItem}
                        itemPropName="assessment"
                        textForEmptyList={texts.noAssessmentsAvailable}
                        classNameForEmptyList={classes.EmptyState}
                    />
                </div>
            </div>
        </Widget >
    );
};

export default CoursesAndAssessmnetsDomainWidget;